import { BrandEnvService, DomainCode } from './brand-env.service';
import { EncryptionService } from './encryption.service';
import { polyfill } from 'es6-promise';
polyfill();
import 'whatwg-fetch';
import fetch from 'isomorphic-fetch';

export var DelinquentService = (function() {

    var delinquentStatus;

    function callRogersApi(params) {
        var url = '/web/RogersServices.portal/totes/api/v1/delinquentStatus';
        var data = {
            applicationId: BrandEnvService.getApplicationId(),
            accountNumber: BrandEnvService.getAccountNumber()
        };

        return fetch(url, {
            method: 'POST',
            body: JSON.stringify(data),
            headers: {
                'Content-Type': 'application/json'
            }
        }).then(function(res) {
            return res.json();
        }).then(function (res) {
            delinquentStatus = res.status;
            return delinquentStatus;
        });
    }

    function callFidoApi() {
        return EncryptionService.getDelinquentStatusFidoCx();
    }

    return {
        getStatus: function() {
            return BrandEnvService.getDomainCode() === DomainCode.ROGERS
                ? callRogersApi()
                : callFidoApi();
        }
    };
})();
